import { useInstantSearch } from 'react-instantsearch';

import { ExtendedUIState } from '@sorare/core/src/components/search/InstantSearch/types';
import { useSearchCardsContext } from '@sorare/core/src/contexts/searchCards';

import { useRelevantRefinements } from 'hooks/search/useRelevantRefinements';

type Props = {
  countQuery?: boolean;
  countSealed?: boolean;
  excludeFromCount?: string[];
};

export const useFiltersCount = ({
  countQuery = true,
  countSealed = true,
  excludeFromCount,
}: Props = {}) => {
  const refinements = useRelevantRefinements();
  const {
    gameweekFilter,
    dailyFilter,
    probablePitchersFilter,
    notInLineUpFilter,
    competitionEligibilityFilter,
    promotion,
    customDecksFilter,
    promotionalEvent,
    sealed,
    watchlistFilter,
  } = useSearchCardsContext();
  const {
    indexUiState: { query, exclusions = {} },
  } = useInstantSearch<ExtendedUIState>();

  return (
    refinements.filter(r => !excludeFromCount?.includes(r.attribute)).length +
    Object.values(exclusions).filter(Boolean).length +
    (gameweekFilter ? 1 : 0) +
    (dailyFilter ? 1 : 0) +
    (probablePitchersFilter ? 1 : 0) +
    (watchlistFilter ? 1 : 0) +
    (notInLineUpFilter ? 1 : 0) +
    (competitionEligibilityFilter ? 1 : 0) +
    (promotion ? 1 : 0) +
    (promotionalEvent ? 1 : 0) +
    (countQuery && query ? 1 : 0) +
    (countSealed && sealed !== undefined ? 1 : 0) +
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    ((customDecksFilter && customDecksFilter.length) || 0)
  );
};
